<template>
  <DBox
    :id="'cmp-distribution-suppliers-sidewindow-order_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('order_string')}`"
    @addClick="onAddClick"
  >
    <NTable
      class="dbox1"
      id="distribution-suppliers-sidewindow-order_list"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('order_date')">
            <span
              @click.stop="(e) => onSelectedOrder(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['supplier_order_date']"
            >
              {{ item["supplier_order_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('order_ref')">
            <span class="txtov text-right" :title="item['supplier_order_id']">
              {{ item["supplier_order_id"] }}
            </span>
          </td>
          <td v-bind="tdcon('order_type')">
            <span class="txtov" :title="item['supply_order_type_name']">
              {{ item["supply_order_type_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('account')">
            <span class="txtov" :title="item['reference']">
              {{ item["reference"] }}
            </span>
          </td>
          <td v-bind="tdcon('description')">
            <!-- <span class="txtov" :title="item['description']">
              {{ item["description"] }}
            </span> -->
            <TextField2
              :id="'description'"
              :showLabel="false"
              :bb="'0px'"
              :disabled="item['disabled']"
              :value="item['description']"
              @blur="(e) => onTextFieldDesChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('accounted')">
            <div class="accounted-container">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1 disabled2">
                  <input
                    type="checkbox"
                    :name="'accounted_flag'"
                    :id="'accounted_flag'"
                    :checked="item['accounted_flag'] == '1'"
                    :disabled="true"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
              <div>
                <span class="txtov" :title="item['accounted_date']">
                  {{ item["accounted_date"] }}
                </span>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('value')">
            <div class="order_value">
              <span
                :style="{
                  paddingRight: !item['currency_iso'] ? '28px' : '0px',
                }"
                class="txtov text-right"
                :title="item['order_value']"
              >
                {{ item["order_value"] }} &nbsp;
                <span>{{ item["currency_iso"] }}</span>
              </span>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openWindow } from "../../../../utility";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionSupplierActions } from "../../store/suppliers/actions";
import { distributionSupplierOrderListLDTRoutes } from "../../router/routes";
export default {
  components: {
    DBox,
    NTable,
  },
  props: ["selectedSupplierDetails"],
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    list: function () {
      return this.selectedSupplierDetails.orders || [];
    },
    headers: function () {
      return [
        createTableHeader("order_date", { f: 0.7, mw: 100 }),
        createTableHeader("order_ref", { mw: 80, ta: "right" }),
        createTableHeader("order_type", { mw: 160 }),
        createTableHeader("account", { mw: 160 }),
        createTableHeader("description"),
        createTableHeader("accounted", { mw: 120, ta: "center" }),
        createTableHeader("value", { mw: 130, ta: "right" }),
      ];
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierActions),
    onAddClick: function () {
      this.$emit("add_click", "add_order_form");
    },
    onSelectedOrder: function (item) {
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: item.supplier_order_id,
          tab: "overview",
        },
      });
    },
    onTextFieldDesChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.supplier_order_id,
        table: "l_supplier_orders",
      });
      this.updateData(item);
    },
    onStatementDelete: async function (item) {
      //   const confirmationResult = await confirmDelete(
      //     "Statement",
      //     item.royalty_account_name
      //   );
      //   if (confirmationResult === "OK") {
      //     const res1 = await AccountsService.countRoyaltyPeriodPayment({
      //       ...item,
      //     });
      //     const res2 = await AccountsService.royaltyPeriodInvoiceInfo({
      //       ...item,
      //     });
      //     if (res1?.data?.request_status == "SUCCESS" && !res2?.data?.invoice) {
      //       const res3 = await AccountsService.removeRoyaltyPeriod({
      //         ...item,
      //       });
      //       const statements = this.selectedSupplierDetails?.statement_data.filter(
      //         (b) => b.royalty_period_id !== item.royalty_period_id
      //       );
      //       this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
      //         royalty_account_id:
      //           this.selectedSupplierDetails?.account?.royalty_account_id,
      //         statement_data: [...statements] || [],
      //       });
      //     }
      //   }
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.royalty_period_id,
        table: "l_royalty_periods",
      });
      this.updateData(item);
    },

    onLockClick: function (item) {
      item.lock_flag = item.lock_flag == 0 ? 1 : 0;
      this.$emit("changed", {
        name: "lock_flag",
        value: item.lock_flag,
        kVal: item.royalty_period_id,
        table: "l_royalty_periods",
      });
      this.updateData(item);
    },
    onStatementWindow: function (item) {
      openWindow(item.stmt_link, "_blank", { wr: 0.7, hr: 0.7 });
    },
    updateData: function (item) {
      const orders = this.selectedSupplierDetails.orders.map((b) => {
        if (b.supplier_order_id === item.supplier_order_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.DistributionSupplierOrderList.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        orders: orders || [],
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-suppliers-sidewindow-order_list {
  .link {
    padding-top: 10px;
  }
  .accounted-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    div {
      margin-right: 5px;
    }
  }
}
</style>
